<template>
  <v-navigation-drawer v-model="expanded" :mini-variant.sync="mini" app>
    <v-list>
      <v-list-item>
        <v-list-item-avatar color="primary">
          <span class="white--text headline"
            >{{ user.firstName[0].toUpperCase()
            }}{{ user.lastName[0].toUpperCase() }}</span
          >
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ nameText }}</v-list-item-title>
          <v-list-item-subtitle>{{ roleName }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-menu
      offset-y
      bottom
      transition="scale-transition"
      origin="center center"
    >
      <template v-slot:activator="{ on }">
        <div class="pa-4">
          <v-btn block color="primary" dark v-on="on">
            New
            <v-icon>add</v-icon>
          </v-btn>
        </div>
      </template>
      <v-list>
        <div v-for="(action, index) in quickActions" :key="index">
          <v-list-item v-if="action.visible" @click="handleClick(action)">
            <v-list-item-title>{{ action.text }}</v-list-item-title>
          </v-list-item>
        </div>
      </v-list>
    </v-menu>
    <v-list>
      <div v-for="item in menu" :key="item.title">
        <div v-if="item.children.length">
          <v-list-group :prepend-icon="item.icon" class="settings">
            <template v-slot:activator>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </template>
            <div v-for="child in item.children" :key="child.title">
              <v-list-item
                v-if="child.visible"
                @click="navigate(child.path)"
                link
                color="primary"
              >
                <v-list-item-icon>
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ child.title }}</v-list-item-title>
              </v-list-item>
            </div>
          </v-list-group>
        </div>
        <div v-else>
          <v-list-item
            v-if="item.visible"
            @click="navigate(item.path)"
            link
            color="primary"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </div>
      </div>
    </v-list>

    <template v-slot:append>
      <v-layout justify-center mt-4>
        <v-flex ml-0 mt-10 pl-4 xs4>
          <p class="font-weight-light caption">Powered by</p>
        </v-flex>
        <v-flex xs4>
          <v-img
            :src="settings.portalLogic.logo"
            height="60"
            width="60"
          ></v-img>
        </v-flex>
      </v-layout>
    </template>
  </v-navigation-drawer>
</template>
<script>
import { associateMenu, userMenu } from "@/modules/sidebarMenu";
import settingsMixin from "../mixins/settingsMixin";
import { get } from "lodash";
import {
  associateQuickActions,
  userQuickActions,
} from "@/modules/quickActions";

export default {
  name: "Sidebar",
  inject: ["reactiveInjected"],
  mixins: [settingsMixin],
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
    width: {
      type: [Number, String],
      default: "220",
    },
  },
  watch: {
    expanded(val) {
      this.$emit("update:expanded", val);
    },
  },
  data() {
    return {
      mini: false,
      associateMenu,
      userMenu,
      associateQuickActions,
      userQuickActions,
    };
  },
  computed: {
    user() {
      return get(this, "reactiveInjected.activeUser");
    },
    roleName() {
      return get(this, "reactiveInjected.activeUser.roleName");
    },
    nameText() {
      const user = get(this, "reactiveInjected.activeUser");
      return `${user.lastName}, ${user.firstName}`;
    },
    quickActions() {
      const {
        isAssociate,
        isUser,
        associateQuickActions,
        userQuickActions,
        activeUser,
        reactiveInjected,
      } = this;
      return isAssociate
        ? associateQuickActions(reactiveInjected.activeUser)
        : isUser
        ? userQuickActions(reactiveInjected.activeUser)
        : [];
    },
    menu() {
      const { isAssociate, isUser, associateMenu, userMenu } = this;
      const { activeUser: user } = this.reactiveInjected;
      return isAssociate ? associateMenu(user) : isUser ? userMenu(user) : [];
    },
    isAssociate() {
      const userType = get(this, "reactiveInjected.activeUser.userType");
      return userType === "associate";
    },
    isUser() {
      const userType = get(this, "reactiveInjected.activeUser.userType");
      return userType === "user";
    },
  },
  methods: {
    navigate(path) {
      if (path === "AssociateLogin") {
        localStorage.removeItem("AssociateLogin");
      }
      this.$router.push({ name: path });
    },
    handleClick(action) {
      const { event, params } = action;
      if (event === "navigate") {
        const { path } = params;
        this.$router.push({ name: path });
      } else if (event === "open-modal") {
        const { modal } = params;
        this.$emit("open-modal", modal);
      }
    },
  },
};
</script>

<style scoped>
.settings >>> .v-list-group__items {
  background-color: rgba(247, 229, 223) !important;
}

.page-title {
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  margin-left: 15px;
  margin-top: 10px;
}

.page-subtitle {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  margin-left: 15px;
  margin-top: 10px;
}
</style>
